// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.inventory.PropertyValuesResponse */
/* istanbul ignore next */
@GandalfModel
export class PropertyValuesResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	hasValidValues!: boolean | null;

	@GandalfProperty({ designType: Number })
	majorStepSize!: number | null;

	@GandalfProperty({ designType: Number })
	maxValue!: number | null;

	@GandalfProperty({ designType: Number })
	minValue!: number | null;

	@GandalfProperty({ designType: Number })
	minorStepSize!: number | null;

}
